import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { reloadOnceForStaleChunk } from './lib/chunkReload';

// Auto-recover from stale lazy-chunk imports after a deploy. Vite
// dispatches `vite:preloadError` on window when a dynamic import /
// modulepreload fails — typically because a newer deploy replaced the
// hashed chunk this older tab was pointing at. Reload once (loop-guarded)
// to pull the fresh index.html + chunk map. preventDefault stops Vite
// rethrowing the error to window.onerror once we've handled recovery.
// See lib/chunkReload.ts.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnceForStaleChunk();
});

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Release identifier — wired through deploy.sh from the
    // commit SHA, so Sentry can match minified events to the
    // sourcemaps the @sentry/vite-plugin uploaded at build time.
    // Empty in dev / when the build arg is absent — Sentry then
    // tags events with no release, which is the same behaviour as
    // before this PR.
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.1,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. See https://github.com/GoogleChrome/web-vitals
reportWebVitals();
